<mat-nav-list>
  <mat-list-item (click)="openBefore()"> Показать до </mat-list-item>
  <mat-list-item (click)="openAfter()"> Показать после </mat-list-item>
  <mat-list-item (click)="openAround()"> Показать до и после </mat-list-item>
</mat-nav-list>
